{
  "commonHeader": {
    "toggleSidebar": "Kenar çubuğunu aç veya kapat",
    "cartLoading": "Alışveriş sepeti yükleniyor",
    "cart": "Alışveriş sepeti",
    "aicForAdmin": {
      "ariaLabel": "Yöneticiler için yapay zeka"
    },
    "usersResults": "Kullanıcılar, {0} sonuç",
    "settingsResults": "Ayarlar, {0} sonuç",
    "navigationResults": "Gezinme, {0} sonuç",
    "learnMoreAbout": "{0} hakkında daha fazla bilgi",
    "close": "Kapat",
    "products": "Ürünler",
    "moreActions": "Diğer işlemler",
    "search": "Ara",
    "searchPlaceholderAll": "Kullanıcı, hesap ayarı veya gezinme ara",
    "searchPlaceholderUsers": "Kullanıcı veya gezinme ara",
    "searchPlaceholderSettings": "Hesap ayarı veya gezinme ara",
    "searchPlaceholderNav": "Gezinmede ara"
  },
  "footerCopyright": {
    "language": "Dil {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Yönetici menüsü"
    }
  },
  "shared": {
    "close": "Kapat",
    "sideMenu": {
      "personalAria": "Kişisel menü",
      "adminAria": "Yönetici menüsü",
      "mainNav": "Ana gezinme",
      "submenu": "Alt menü",
      "pinnedSection": "{0} sabitlendi",
      "sideMenuAria": "Yan menü",
      "pinItem": "{0} öğesini sabitle",
      "unpinItem": "{0} öğesinin sabitlemesini kaldır",
      "reorderGrabbed": "{0} yeniden sıralanıyor, tutuldu. Taşımak için yukarı ve aşağı okları, bırakmak için boşluk veya Enter, iptal etmek için Escape kullanın.",
      "reorderIdle": "{0} öğesini yeniden sıralayın. Tutmak için boşluk veya Enter tuşuna basın.",
      "hintHandlePin": "Sürükleme tutamacına ve sabitleme düğmesine gitmek için Tab’a basın",
      "hintHandle": "Sürükleme tutamacına gitmek için Tab’a basın",
      "hintPin": "Sabitleme düğmesine gitmek için Tab’a basın",
      "upgradeToPro": "Pro’ya yükselt"
    },
    "item": "Öğe"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Yeni deneyimi dene"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Kapat"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Bölümler artık kullanılabilir"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Harici hesapları yönetin"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "Adres Defteri, Müşteri Dizini olacak"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Ürün Türü",
    "itemLableForFeedback": "Geri Bildirim"
  }
}
